import { toast } from "react-toastify";

export const printSummary = (items, summary, reciptDetails, userID) => {
  const list = Array.isArray(items) ? items : [];
const receiptUserId = String(userID || "").trim();

  const s = summary || {};
  const receipt = reciptDetails || {};

  const businessName = receipt?.business_name || "Chaafo";
  const address = receipt?.address || "";
  const phoneNo = receipt?.phone_no || "";
  const gstNo = receipt?.gst || "";

  const totalAmount = Number(s.totalSummaryAmount ?? 0);

  // payment totals
  const cashTotal = Number(s.totalCashCollectedAmount ?? 0);
  const upiTotal = Number(s.totalUPICollectedAmount ?? 0);
  const cardTotal = Number(s.totalCardCollectedAmount ?? 0);

  // payment counts
  const cashCount = Number(s.totalCashCollectedCount ?? 0);
  const upiCount = Number(s.totalUPICollectedCount ?? 0);
  const cardCount = Number(s.totalCardCollectedCount ?? 0);

  // order counts
  const deliveryCount = Number(s.totalHomeDeliveryCount ?? 0);
  const takeawayCount = Number(s.totalTakeawaycount ?? 0);
  const officeOrderCount = Number(s.officeOrderCount ?? 0);
  const carOrderCount = Number(s.carOrderCount ?? s.totalCarOrdercount ?? 0);
  const diningCount = Number(s.diningCount ?? 0);
  const roomOrderCount = Number(s.roomOrderCount ?? 0);
  const totalOrdersCount = Number(
    s.totalOrdersCount ??
      deliveryCount +
        takeawayCount +
        officeOrderCount +
        carOrderCount +
        diningCount +
        roomOrderCount,
  );

  // order totals
  const deliveryTotal = Number(s.homeDeliveryTotal ?? 0);
  const takeawayTotal = Number(s.takeawayTotal ?? 0);
  const officeOrderTotal = Number(s.officeOrderTotal ?? 0);
  const carOrderTotal = Number(s.carOrderTotal ?? s.totalcarorderAmount ?? 0);
  const diningTotal = Number(s.diningTotal ?? 0);
  const roomOrderTotal = Number(s.roomOrderTotal ?? 0);

  // charges
  const totalGST = Number(s.totalFoodGSTCharges ?? 0);
  const totalDeliveryCharge = Number(s.totalDeliveryCharges ?? 0);
  const platformCharge = Number(s.totalPlatformCharges ?? 0);
  const platformTax = Number(s.totalPlatformChargesTax ?? 0);
  const settlementValue = Number(s.totalSettelementValue ?? 0);
  const totalMessageCharges = Number(s.totalMessageCharges ?? 0);

  if (!list || list.length === 0) {
    console.error("No data for summary print");
    return;
  }

  const getShortType = (type = "") => {
    const value = String(type)
      .toLowerCase()
      .replace(/[\s_-]/g, "");

    if (value.includes("take")) return "TKW";
    if (value.includes("home")) return "HWD";
    if (value.includes("din")) return "DIN";
    if (value.includes("car")) return "CAR";
    if (value.includes("office")) return "OFF";
    if (value.includes("room")) return "ROOM";

    return String(type || "-").toUpperCase();
  };

  const selectedDate =
    list[0]?.fromDate || new Date().toLocaleDateString("en-GB");

  // ---------------- HTML ----------------

  const html = `
  <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
        }

        .header {
          text-align: center;
          border-bottom: 1px dashed #000;
        }

        .header2 {
          border-bottom: 1px dashed #000;
          padding: 2px 0; 
          margin: 2px 0;
        }
        .header2 p {
          text-align: center;
          width: 100%;
        }
        .headerTable {
          border-bottom: 1px dashed #000;
        }

        .headerTotal {
          border-bottom: 1px dashed #000;
          padding: 2px 0;
        }

        .headerEnd {
          text-align: center;
        }

        .textSizeLarge { font-size: 14px; margin: 4px 0; }
        .textSizeMid { font-size: 9px;  margin: 2px 0; }
        .textSizeSmall { font-size: 9px; margin: 0; }

        table {
          width: 100%;
          border-collapse: collapse;
           table-layout: auto; 
        }

        th {
              white-space: nowrap;  
            }

        th, td {
          font-size: 10px;
          padding: 1px;
          text-align: center;
        }

        .hr-dashed {
          border-bottom: 1px dashed #000;
          margin: 2px 0;
        }
      </style>
    </head>

    <body>

  <div class="header">
  <p class="textSizeLarge"><b>${businessName}</b></p>
  <p class="textSizeMid">${address}</p>
  <p class="textSizeMid">PH: ${phoneNo}</p>

  <p class="textSizeMid">
    GST: ${gstNo}
  </p>

  ${
    receiptUserId === "A1222"
      ? `
        <p class="textSizeMid">
          FSSAI NO: 12724052000539
        </p>
      `
      : ""
  }

  <p class="textSizeLarge">
    <b>** SUMMARY REPORT **</b>
  </p>
</div>

     <div class="header2">
  <p class="textSizeMid" style="text-align:center;">
    Date : ${selectedDate}
  </p>
</div>

      <div class="headerTable">
        <table>
          <thead>
            <tr>
              <th>O.ID</th>
              <th>BILL NO.</th>
              <th>TYP</th>
              <th>MOD</th>
              <th>ORD PRICE</th>
            </tr>
          </thead>

          <tbody>
            ${[...list]
              .reverse()
              .map(
                (o) => `
              <tr>
                <td>${o.daily_order_id}</td>
                <td>${o.orderid}</td>
                <td>${getShortType(o.orderType)}</td>
                <td>${o.payment_mode}</td>
               <td style="font-weight:600;">
                  ${Number(o.totalOrderPrice).toFixed(2)}
                </td>
              </tr>
            `,
              )
              .join("")}
          </tbody>
        </table>
      </div>

     <div class="headerTotal">

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Cash Collected (${cashCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${cashTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total HWD Odr Amount (${deliveryCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${deliveryTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Tkway Odr Amount (${takeawayCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${takeawayTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Car Odr Amount (${carOrderCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${carOrderTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Office Odr Amount (${officeOrderCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${officeOrderTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Dining Odr Amount (${diningCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${diningTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Room Odr Amount (${roomOrderCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${roomOrderTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:800;">Total Orders Count :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>${totalOrdersCount}</b></p>
</div>

<div class="hr-dashed"></div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total H.Del Odr Amount (${deliveryCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${deliveryTotal.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Tkway Odr Amount (${takeawayCount}) :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${takeawayTotal.toFixed(2)}</b></p>
</div>

<div class="hr-dashed"></div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:800;"><b>Total Order Amount :</b></p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${totalAmount.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Delivery Charge:</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${totalDeliveryCharge.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Food Gst :</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${totalGST.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Platform Charge:</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${platformCharge.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Platform Tax:</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${platformTax.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between; margin-bottom:2px;">
  <p class="textSizeMid" style="font-weight:600;">Total Message Charges:</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${totalMessageCharges.toFixed(2)}</b></p>
</div>

<div style="display:flex; justify-content:space-between;">
  <p class="textSizeMid" style="font-weight:900;">Total Settlement Amount:</p>
  <p class="textSizeMid" style="width:60px; text-align:right; padding-right:6px;"><b>Rs. ${settlementValue.toFixed(2)}</b></p>
</div>

</div>

  <div class="headerEnd" style="padding:6px 0;">
  <p class="textSizeSmall" style="margin:0;">Order Type Legends:</p>

  <p class="textSizeSmall" style="margin:2px 0;">
   TKW = Takeaway | HWD = Home Delivery | DIN = Dining | CAR = Car Order | OFF = Office | ROOM = Room Order
  </p>

  <p class="textSizeMid" style="margin:4px 0;">
    ** END OF SUMMARY REPORT **
  </p>

  <div class="hr-dashed" style="margin-top:4px;"></div>
</div>

    </body>
  </html>
  `;

  const win = window.open("", "_blank");

  if (!win) {
    toast.error("Popup blocked");
    return;
  }

  win.document.write(html);
  win.document.close();

  setTimeout(() => {
    win.print();
    win.close();
  }, 300);
};

